import React from 'react'
import { RequestButton } from '../../request-components/request-components'
import ConfirmationModal from '../../confirmation-modal/confirmation-modal'
import { User, UserRoleKind } from '../../../api/users'
import { useModal } from '../../modal'
import {
  useDiscontinueUserOrganizationRoleMutation,
  useDiscontinueWorkerAssociationMutation,
} from '../../../queries/users'
import { Element, Icon } from 'react-bulma-components'
import { Organization } from '../../../api/organizations'
import { getUserLabel } from '../../../utils/users'
import { ButtonProps } from '../../../types/bulma'
import { StopIcon } from '@heroicons/react/outline'

interface DiscontinueAssociationButtonProps {
  user: User
  roleKind: UserRoleKind
  organization: Organization
  color?: ButtonProps['color']
}

const DiscontinueAssociationButton: React.FC<DiscontinueAssociationButtonProps> = ({
  user,
  roleKind,
  organization,
  color,
}) => {
  const modal = useModal()
  const discontinueUserOrganizationRoleMutation = useDiscontinueUserOrganizationRoleMutation()
  const discontinueWorkerAssociationMutation = useDiscontinueWorkerAssociationMutation()

  return (
    <>
      <RequestButton
        size={'small'}
        variant="danger"
        onClick={() => modal.setIsDisplayed(true)}
        mutation={discontinueUserOrganizationRoleMutation}
        color={color}
      >
        <span className="is-flex is-align-items-center">
          <Icon size="small" mr={1}>
            <StopIcon className="h-4 w-4" />
          </Icon>
          <span>Interrompre la collaboration</span>
        </span>
      </RequestButton>
      <ConfirmationModal
        show={modal.isDisplayed}
        onCancel={() => modal.setIsDisplayed(false)}
        onConfirm={() => {
          if (roleKind === 'worker')
            discontinueWorkerAssociationMutation.mutate({ workerId: user._id })
          else discontinueUserOrganizationRoleMutation.mutate({ userId: user._id })
          modal.setIsDisplayed(false)
        }}
      >
        <Element renderAs="p" mb={3}>
          Êtes-vous certain de vouloir arrêter la collaboration avec{' '}
          <Element renderAs="strong">
            {user.firstName && user.lastName ? getUserLabel(user) : user.email}
          </Element>
          ?
        </Element>
        {roleKind === 'worker' ? (
          <Element>Vous ne pourrez plus lui attribuer de Missions.</Element>
        ) : (
          <Element>Il ne pourra plus accéder à l'espace TeamTim de {organization.name}.</Element>
        )}
      </ConfirmationModal>
    </>
  )
}

export default DiscontinueAssociationButton
